import styled from '@emotion/styled';
import Close from '@icon/Close';
import { Fonts, Spacings, mediaQuery } from '@styles/index';

export const Container = styled.div`
  padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_6B} ${Spacings.SPACING_6B};
  display: flex;
  position: relative;
  flex-direction: column;
  width: ${Spacings.SPACING_120B};
  ${mediaQuery.uptoMobile} {
    width: 100%;
    padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_4B};
  }
`;

export const CloseIcon = styled(Close)`
  position: absolute;
  left: ${Spacings.SPACING_6B};
  top: ${Spacings.SPACING_6B};
  cursor: pointer;
  z-index: 1;
  color: var(--color-i-black);
`;

export const Subject = styled.div`
  color: ${({ $color }) => $color || 'var(--color-i-violet-12)'};
  font-size: ${Fonts.EXTRA_SMALL};
  font-weight: ${Fonts.HEAVY};
  letter-spacing: 0.64px;
  text-transform: uppercase;
  margin-top: ${Spacings.SPACING_10B};
`;

export const TitleText = styled.h4`
  font-weight: ${Fonts.HEAVY};
  font-size: ${Fonts.LARGE_2};
  line-height: ${Fonts.H4};
  color: var(--color-text-primary);
  margin-top: ${({ $hasSubject }) =>
    $hasSubject ? Spacings.SPACING_2B : Spacings.SPACING_10B};
`;

export const MetaText = styled.p`
  font-size: ${Fonts.P2};
  color: var(--color-text-secondary);
  margin-top: ${Spacings.SPACING_2B};
`;

export const Divider = styled.div`
  height: 1px;
  background-color: var(--color-divider);
  margin: ${Spacings.SPACING_4B} 0;
`;

export const Section = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacings.SPACING_4B};
`;

export const SectionIcon = styled.span`
  position: relative;
  display: inline-flex;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
  ${({ $disabled }) =>
    $disabled
      ? `
    filter: grayscale(1);
  `
      : ''}
  ${({ $color, $disabled }) =>
    $color && !$disabled
      ? `
    &::after {
      content: '';
      position: absolute;
      inset: 0;
      background-color: ${$color};
      mix-blend-mode: color;
      pointer-events: none;
    }
  `
      : ''}
`;

export const ClickableSection = styled.button`
  display: flex;
  align-items: center;
  gap: ${Spacings.SPACING_4B};
  width: 100%;
  background: none;
  border: none;
  padding: 0;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  text-align: left;
  opacity: ${({ $disabled }) => ($disabled ? 0.45 : 1)};
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
`;

export const SectionBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const SectionTitle = styled.span`
  font-size: ${Fonts.H6};
  font-weight: ${Fonts.HEAVY};
  color: var(--color-text-primary);
`;

export const SectionMeta = styled.span`
  font-size: ${Fonts.P2};
  color: var(--color-text-secondary);
  margin-top: ${Spacings.SPACING_1B};
`;

export const PdfButtons = styled.div`
  display: flex;
  gap: ${Spacings.SPACING_3B};
  margin-top: ${Spacings.SPACING_3B};
`;

export const PdfButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${Spacings.SPACING_2B};
  background-color: var(--color-base-1);
  border: 1px solid var(--color-i-divider);
  border-radius: ${Spacings.SPACING_1B};
  padding: ${Spacings.SPACING_2B} ${Spacings.SPACING_3B};
  font-size: ${Fonts.P2};
  font-weight: ${Fonts.SEMIBOLD};
  color: var(--color-text-primary);
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.45 : 1)};
  white-space: nowrap;
`;
